import { ReactNode } from "react"
import { NavLink, useLocation } from "react-router-dom"
import { useSelector } from 'react-redux'
import { RootState } from '../../store/configure-store'

export interface SubPage {
    label: string
    route: string
    icon?: ReactNode
    iconOnly?: boolean
    title?: string
    preserveSearch?: boolean
}

interface NavHeaderProps {
    subPages: SubPage[]
    preserveCompany?: boolean
}

export const NavHeader: React.FC<NavHeaderProps> = ({ subPages, preserveCompany = true }) => {
    const company = useSelector((state: RootState) => state.companyName.value)
    const location = useLocation()
    const buildTo = (page: SubPage) => {
        const params = new URLSearchParams(page.preserveSearch ? location.search : '')
        if (preserveCompany && company) {
            params.set('company', company)
        }
        const query = params.toString()
        return query ? `${page.route}?${query}` : page.route
    }

    return <nav className="nav-header">
        <ul className="clean-list">
            {subPages.map(page => <li key={page.route}>
                <NavLink
                    to={buildTo(page)}
                    title={page.title || page.label}
                    aria-label={page.label}
                    className={({ isActive }) =>
                        `nav-header__link${page.iconOnly ? ' nav-header__link--icon-only' : ''}${isActive ? ' active' : ''}`
                    }
                >
                    {page.icon && <span className="nav-header__icon" aria-hidden="true">{page.icon}</span>}
                    {page.iconOnly ? <span className="nav-header__label nav-header__label--sr-only">{page.label}</span> : page.label}
                </NavLink>
            </li>)}
        </ul>
    </nav>
}
